export default __webpack_public_path__ + "static/media/forestly-noexpl-03b_EN.5e392273.png";